import React from "react";
import Constants from "../../../../../constant";
import { ICertificates } from "../../../../../models/certificates.model";
import { hasAppReactNative } from "../../../../../util";
import ColumnView from "../column";
import "./index.scss";
const NumberDownloads = ({ certificates }: { certificates: ICertificates }) => {
    return (
        <div>
            <div className="list-chart">
                <ColumnView
                    platformIds={[Constants.PLATFORM_WEB]}
                    certificates={certificates}
                    eventName="download_app"
                />
                <ColumnView
                    platformIds={[
                        Constants.PLATFORM_FLUTTER_ANDROID,
                        Constants.PLATFORM_FLUTTER_IOS,
                    ]}
                    certificates={certificates}
                    eventName="first_open"
                />
                {hasAppReactNative(certificates) && (
                    <ColumnView
                        platformIds={[
                            Constants.PLATFORM_REACT_NATIVE_ANDROID,
                            Constants.PLATFORM_REACT_NATIVE_IOS,
                        ]}
                        certificates={certificates}
                        eventName="first_open"
                    />
                )}
            </div>
        </div>
    );
};

export default NumberDownloads;
